import styled from '@emotion/styled'
import { ExtranetContainer } from '@pharmac-extranet/shared'
import { useEffect, useState } from 'react'
import { EXTRANET_INACTIVITY_TIMESTAMP_STORAGE_KEY } from '../components/inactivity-modal/InactivityModal'
import { useAuthenticationContext } from '../features/authentication/useAuthentication'
import { EXTRANET_CUSTOMERSHIP_STORAGE_KEY } from '../features/customer/CustomerProvider'

const GradientBackground = styled(ExtranetContainer)`
  background: var(--color-gradient-background);
  height: 100%;
`

export const LogoutView = () => {
  const [done, setDone] = useState<boolean>(false)

  const { doLogout, user } = useAuthenticationContext()

  useEffect(() => {
    if (user) {
      window.localStorage.removeItem(EXTRANET_CUSTOMERSHIP_STORAGE_KEY)
      window.localStorage.removeItem(EXTRANET_INACTIVITY_TIMESTAMP_STORAGE_KEY)

      doLogout({ redirectUri: window.location.origin }).then(() => {
        setDone(true)
      })
    }
  }, [])

  if (!done) return <GradientBackground />

  return null
}
